import React, { Component } from "react";
import _ from "lodash";
import OfflineReportTable from "./OfflineReportTable";

class OfflineCriminalSearches extends Component {
  componentDidMount() {}

  render() {
    const crimAcxiomRecs = _.get(
      this.props.data,
      "offline.offlineCriminal[0].crimAcxiom",
      []
    );
    const selectedRecs = _.filter(
      crimAcxiomRecs,
      c => _.get(c, "requestCode[0]", 0) < 5000
    );
    const ordSelectedRecs = _.orderBy(selectedRecs, o =>
      _.get(o, "reqStatus[0]")
    );
    return <OfflineReportTable {...this.props} recs={ordSelectedRecs} />;
  }
}

export default OfflineCriminalSearches;



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineCriminalSearches.js